// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { createInventoryTransfer } from "./schema/create-inventory-transfer";
import { addProductsToSupplier } from "./schema/supplier-products/add-products-to-supplier";
import { getProductSuppliers } from "./schema/supplier-products/get-product-suppliers";
import { getSupplierProductCosts } from "./schema/supplier-products/get-supplier-product-costs";
import { validateProductsForSupplier } from "./schema/supplier-products/validate-products-for-supplier";
import { batchCreateSuppliers } from "./schema/suppliers/batch-create-suppliers";
import { createSupplier } from "./schema/suppliers/create-supplier";
import { deleteSupplier } from "./schema/suppliers/delete-supplier";
import { getSupplier } from "./schema/suppliers/get-supplier";
import { getSuppliers } from "./schema/suppliers/get-suppliers";
import { mapSupplierColumns } from "./schema/suppliers/map-supplier-columns";
import { parseAddresses } from "./schema/suppliers/parse-addresses";
import { updateSupplier } from "./schema/suppliers/update-supplier";
import { addTransferFile } from "./schema/transfers/add-transfer-file";
import { createTransfer } from "./schema/transfers/create-transfer";
import { deleteTransfer } from "./schema/transfers/delete-transfer";
import { deleteTransferFile } from "./schema/transfers/delete-transfer-file";
import { getTransfer } from "./schema/transfers/get-transfer";
import { getTransfers } from "./schema/transfers/get-transfers";
import { submitTransferOrder } from "./schema/transfers/submit-transfer-order";
import { updateTransfer } from "./schema/transfers/update-transfer";
import { createInventoryViewFolder } from "./schema/views/create-inventory-view-folder";
import { deleteInventoryView } from "./schema/views/delete-inventory-view";
import { deleteInventoryViewFolder } from "./schema/views/delete-inventory-view-folder";
import { getInventoryViewsAndFolders } from "./schema/views/get-inventory-views-and-folders";
import { saveInventoryView } from "./schema/views/save-inventory-view";
import { updateInventoryViewFolder } from "./schema/views/update-inventory-view-folder";

export const groupE = {
  batchCreateSuppliers,
  createSupplier,
  deleteSupplier,
  getSupplier,
  getSuppliers,
  mapSupplierColumns,
  parseAddresses,
  updateSupplier,
  addProductsToSupplier,
  getProductSuppliers,
  getSupplierProductCosts,
  validateProductsForSupplier,
  addTransferFile,
  createTransfer,
  deleteTransfer,
  deleteTransferFile,
  getTransfer,
  getTransfers,
  submitTransferOrder,
  updateTransfer,
  createInventoryTransfer,
  createInventoryViewFolder,
  deleteInventoryView,
  deleteInventoryViewFolder,
  getInventoryViewsAndFolders,
  saveInventoryView,
  updateInventoryViewFolder,
};
